"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { SectionHeading } from "@/components/cosmic/SectionHeading";
import { Reveal } from "@/components/cosmic/Reveal";
import { JOURNEY } from "@/lib/originBeyond/journey";
import { ArrowRight, Sparkles } from "lucide-react";
export default function OriginBeyond() {
  return <section id="origin-and-beyond" data-nav="dark" className="relative py-16 sm:py-20 lg:py-28 w-full max-w-full overflow-x-clip text-foreground scroll-mt-12">
      <div className="relative z-10 max-w-[76rem] w-full mx-auto px-4 sm:px-6">
        {/* Hairline section divider */}
        <div className="ql-divider mb-14 sm:mb-16" aria-hidden="true" />

        <Reveal>
          <SectionHeading eyebrow="ORIGIN & BEYOND" title="Where did we come from. Where do we go?" description="The science and philosophy of four great questions. Empirical physics, cognitive neuroscience, and cosmological deep time meet centuries of human contemplative inquiry. Scientific evidence is always strictly labelled and diverse cultural traditions are respectfully represented." align="center" />
        </Reveal>

        {/* 4 compact cards from JOURNEY */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mt-10 sm:mt-12">
          {JOURNEY.map((item, index) => {
          const Icon = item.icon;
          const cardContent = <>
                {/* Top specular hairline accent */}
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-border to-transparent group-hover:via-primary/50 transition-colors" />

                <div>
                  {/* Header: Icon & Question Number */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="size-10 rounded-lg bg-card/80 border border-border/60 flex items-center justify-center backdrop-blur-xs text-primary group-hover:drop-shadow-[0_0_8px_var(--glow-primary)] transition-transform duration-300 group-hover:scale-110">
                      <Icon className="size-5" />
                    </div>
                    <span className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground/80">
                      0{item.number} // INQUIRY
                    </span>
                  </div>

                  <h3 className="font-serif text-lg sm:text-xl font-bold tracking-tight text-foreground mb-2 group-hover:text-primary transition-colors leading-snug">
                    {item.title}
                  </h3>

                  <p className="font-sans text-xs sm:text-sm text-muted-foreground leading-relaxed line-clamp-4">
                    {item.teaser}
                  </p>
                </div>

                {/* Card footer CTA link */}
                <div className="mt-5 pt-3 border-t border-border/40 flex items-center justify-between text-primary font-serif text-xs font-semibold uppercase tracking-wider min-h-[32px]">
                  <span>Explore Question</span>
                  <ArrowRight className="size-3.5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" />
                </div>
              </>;
          const cardClass = "ql-card group flex flex-col justify-between h-full p-5 sm:p-6 block transition-all duration-300 hover:border-primary/60 hover:shadow-[0_0_24px_rgba(0,229,255,0.2)]";
          return <Reveal key={item.id} delay={index * 90} className="h-full">
                {item.id === "origin" && <Link to="/WhereDidWeComeFromPage" className={cardClass}>
                    {cardContent}
                  </Link>}
                {item.id === "consciousness" && <Link to="/WhatIsConsciousnessPage" className={cardClass}>
                    {cardContent}
                  </Link>}
                {item.id === "death" && <Link to="/WhatHappensAfterDeathPage" className={cardClass}>
                    {cardContent}
                  </Link>}
                {item.id === "future" && <Link to="/WhereIsEverythingGoingPage" className={cardClass}>
                    {cardContent}
                  </Link>}
              </Reveal>;
        })}
        </div>

        {/* Primary CTA centered below cards */}
        <Reveal delay={400} className="mt-10 sm:mt-12 flex justify-center">
          <Link to="/OriginAndBeyondPage" className="ql-btn min-h-[44px] px-7 py-3 text-sm font-serif uppercase tracking-wider justify-center">
            <Sparkles className="size-4 shrink-0" />
            <span>Begin the journey</span>
            <ArrowRight className="size-4 shrink-0" />
          </Link>
        </Reveal>
      </div>
    </section>;
}